import React from 'react';

const plans = [
    {
        name: 'Starter',
        price: '$499',
        period: '/month',
        desc: 'Perfect for small production facilities starting their digital journey.',
        features: ['Up to 5 Users', 'Basic Traceability', 'Inventory Management', 'Email Support', '50 Batches/Month'],
        cta: 'Get Started',
        popular: false
    },
    {
        name: 'Professional',
        price: '$999',
        period: '/month',
        desc: 'Ideal for growing businesses needing advanced insights and tools.',
        features: ['Unlimited Users', 'End-to-End Traceability', 'Advanced Analytics', 'Priority Support', 'Unlimited Batches', 'Supplier Portal'],
        cta: 'Most Popular',
        popular: true
    },
    {
        name: 'Enterprise',
        price: 'Custom',
        period: '',
        desc: 'Tailored solutions for large-scale industrial operations.',
        features: ['Custom Integrations', 'Dedicated Account Manager', 'On-site Training', 'SLA Guarantees', 'Multi-facility Support'],
        cta: 'Contact Sales',
        popular: false
    }
];

const Pricing = () => {
    return (
        <section id="pricing" className="py-8 bg-white">
            <div className="section-padding">
                <div className="text-center max-w-3xl mx-auto mb-10">
                    <h2 className="heading-lg mb-4">Scalable Pricing for <span className="gradient-text font-black">Any Size</span></h2>
                    <p className="text-p">
                        Choose the plan that fits your current operational scale and upgrade as you grow. Transparent pricing with no hidden fees.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                    {plans.map((p, i) => (
                        <div key={i} className={`relative p-8 rounded-2xl border transition-all duration-500 ${p.popular ? 'border-sky-400 shadow-2xl shadow-indigo-100 -translate-y-2' : 'border-slate-200 shadow-xl shadow-slate-100 -translate-y-1'} flex flex-col`}>
                            {p.popular && (
                                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-indigo-600 to-sky-500 text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider shadow-lg">
                                    Recommended
                                </div>
                            )}
                            <h3 className="text-2xl font-bold mb-2 text-slate-900">{p.name}</h3>
                            <div className="mb-6">
                                <span className="text-4xl font-bold text-slate-900">{p.price}</span>
                                <span className="text-slate-500 ml-1">{p.period}</span>
                            </div>
                            <p className="text-slate-600 mb-8 h-12">{p.desc}</p>

                            <ul className="space-y-4 mb-8 flex-grow">
                                {p.features.map((f, j) => (
                                    <li key={j} className="flex items-center gap-3 text-slate-700">
                                        <svg className="w-5 h-5 text-sky-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                        {f}
                                    </li>
                                ))}
                            </ul>

                            <button
                                className={`w-full py-3 rounded-xl font-bold transition-all ${p.popular ? 'bg-gradient-to-r from-indigo-600 to-sky-500 text-white hover:shadow-lg hover:shadow-indigo-200 active:scale-95' : 'bg-slate-50 text-slate-900 hover:bg-slate-100'}`}
                                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                            >
                                {p.cta}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Pricing;
